import type { PersonRecord } from '@/data/schemas';

export function formatPersonnelDisplay(person: PersonRecord): string {
  const first = person.firstName?.trim() ?? '';
  const last = person.lastName?.trim() ?? '';
  const fullName = `${first} ${last}`.trim() || last || first;
  const role = person.role?.trim();
  return role ? `${fullName} (${role})` : fullName;
}

export function splitAttendeeLines(value?: string | null): string[] {
  if (!value) return [];
  return value
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
}

export function normalizeAttendeeLabel(label: string): string {
  return label.toLowerCase().replace(/\s+/g, ' ').replace(/[’']/g, "'").trim();
}

export function parseAttendeeLine(line: string): {
  name: string;
  role?: string;
} {
  const match = line.match(/^(.*?)(?:\s*\(([^)]+)\))?$/);
  if (!match) {
    return { name: line.trim() };
  }

  const [, name, role] = match;
  return {
    name: name.trim(),
    role: role?.trim() || undefined,
  };
}
